import React, { useState } from 'react';
import {
  Text,
  useResponsiveParams,
  Button,
  NotificationList,
} from 'quanta-ui';
// import { Error, Loading } from '../../../../../../lib/layout';
import { Error, Loading } from 'quanta-flows/modules/layout';
import {
  //GET_FIRE_POLICY_VAR_DETAILS,
  GET_FIRE_UPLOAD_POLICY_VAR_DETAILS,
  UW_QUOTE_APPROVAL,
} from 'quanta-flows/modules/quote/fire';
import { GET_FIRE_POLICY_VAR_DETAILS } from 'quanta-flows/modules/quote/fire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
// import { updateFireQuote } from '../../_graphql/state';
import { updateFireQuote } from 'quanta-flows/modules/quote/fire/state';
import { useMutation, useQuery } from '@apollo/client';
import CustomerSummary from '../common/customer-summary';
import LocationCoverageDetails from '../common/location-coverage-details';
import { useHistory } from 'react-router-dom';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import AdditionalDetailsSummary from '../common/additional-details-summary';
// import TransactionComponent from '../../../../../../lib/security/transaction_component';

//import { TransactionComponent } from 'quanta-flows/modules/security';

//import { QUERY_STATE } from 'quanta-flows/modules/quote/fire';
// import { updateBuyFirePolicyVar } from '../../../../new-policy-issuance/fire/_graphql/state';
// import { updateBuyFirePolicyVar } from '../../../../../../../../../quanta-flows/src/exports';

//import { updateBuyFirePolicyVar } from '../../../../../new-policy-issuance/fire/Standalone Fire/_graphql/state';

import { updateBuyFirePolicyVar } from 'quanta-flows/modules/proposal/fire/state';

export default function FinalisedQuote({
  goToStep,
  productCode,
  productName,
  lobCode,
  role,
}) {
  const [alerts, setAlerts] = useState([]);
  const [underWriterComment, setUnderWriterComment] = useState('');
  const {
    loading: loadingUploadDocsVar,
    error: errorUploadDocsVar,
    data: dataUploadDocsVar,
  } = useQuery(GET_FIRE_UPLOAD_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingFireQuoteVar,
    error: errorFireQuoteVar,
    data: dataFireQuoteVar,
  } = useQuery(GET_FIRE_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      setUnderWriterComment(
        data?.fireQuote?.tabDetails?.additionalTabDetails
          ?.underwriterComment,
      );
    },
  });
const [
    doUWQuoteApproval,
    { loading: loadingUWQuoteApproval, error: errorUWQuoteApproval },
  ] = useMutation(UW_QUOTE_APPROVAL, {
    onCompleted: (data) => {
      updateFireQuote({
        status: data?.fireQuoteUWApproval?.quoteStatus,
        tabDetails: {
          ...dataFireQuoteVar?.fireQuote?.tabDetails,
          additionalTabDetails: {
            ...dataFireQuoteVar?.fireQuote?.tabDetails
              ?.additionalTabDetails,
            underwriterComment: underWriterComment,
          },
        },
      });
      setAlerts([
        {
          id: Date.now() + Math.random(),
          content: <Text>{data?.fireQuoteUWApproval?.message}</Text>,
          type: 'success',
          timeout: 3000,
          disableClose: false,
        },
      ]);
    },
    onError: (error) => {
      updateFireQuote({
        tabDetails: {
          ...dataFireQuoteVar?.fireQuote?.tabDetails,
          additionalTabDetails: {
            ...dataFireQuoteVar?.fireQuote?.tabDetails
              ?.additionalTabDetails,
            underwriterComment: underWriterComment,
          },
        },
      });
      setAlerts([
        {
          id: Date.now() + Math.random(),
          content: <Text>{error?.message}</Text>,
          type: 'error',
          timeout: 3000,
          disableClose: false,
        },
      ]);
    },
  });

  const screenType = useResponsiveParams({
    for_desktop: 'desktop',
    for_mobile: 'mobile',
  });
  const history = useHistory();
  const fetchQuery = useFetchQuery();
  const getGraphQLErrorMessage = (error) => {
    return error.graphQLErrors.length > 0
      ? error.graphQLErrors.map((gerr) =>
          gerr && gerr.message
            ? gerr.message
            : 'Internal Error Occurred',
        )[0]
      : error.message
      ? error.message
      : 'Internal Error Occurred';
  };

  if (
    loadingFireQuoteVar ||
    loadingUploadDocsVar ||
    loadingUWQuoteApproval
  ) {
    return <Loading />;
  }
  if (
    errorFireQuoteVar ||
    errorUploadDocsVar ||
    errorUWQuoteApproval
  ) {
    return (
      <Error
        error={
          errorFireQuoteVar ||
          errorUploadDocsVar ||
          errorUWQuoteApproval
        }
      />
    );
  }
  const { fireQuote } = dataFireQuoteVar;
  const { fireQuoteUploadDocs } = dataUploadDocsVar;

  return (
    <div className={'flex flex-col space-y-4'}>
      <CustomerSummary
        {...{
          //changeDisabled: true,
          fireQuote,
          goToStep,
          loadingPremium: false,
          role,
        }}
      />
      <LocationCoverageDetails
        {...{
          fireQuote,
          goToStep,
          productName,
          role,
        }}
      />
      <AdditionalDetailsSummary
        {...{
          fireQuote,
          fireQuoteUploadDocs,
          goToStep,
          productCode,
          role,
          underWriterComment,
          setUnderWriterComment,
        }}
      />
      {fireQuote?.status?.toString()?.toLowerCase() ===
        'pending uw approval' &&
        role?.toString()?.toLowerCase() === 'underwriter' &&
        (screenType?.toString()?.toLowerCase() === 'mobile' ? (
          <>
            <Text>
              <Button
                disabled={
                  loadingUWQuoteApproval ||
                  loadingFireQuoteVar ||
                  !underWriterComment
                    ? true
                    : false
                }
                size={'small'}
                className={'w-full h-10'}
                flat={false}
                onClick={(_) => {
                  doUWQuoteApproval({
                    variables: {
                      input: {
                        quoteNumber: fireQuote?.quoteNumber,
                        updatedUWQuote: {
                          clauses: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.clauses
                              ?.defaultClauses
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.clauses
                                  ?.defaultClauses
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses?.filter(
                                (udc) => udc,
                              ),
                          },
                          warranties: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.warranties
                              ?.defaultWarranties
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.warranties
                                  ?.defaultWarranties
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties?.filter(
                                (udw) => udw,
                              ),
                          },
                          exclusions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.exclusions
                              ?.defaultExclusions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.exclusions
                                  ?.defaultExclusions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions?.filter(
                                (ude) => ude,
                              ),
                          },
                          conditions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.conditions
                              ?.defaultConditions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.conditions
                                  ?.defaultConditions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions?.filter(
                                (udc) => udc,
                              ),
                          },
                        },
                        underwriterComment: underWriterComment,
                        // underwriterComment:
                        //   fireQuote?.tabDetails?.additionalTabDetails
                        //     ?.underwriterComment,
                        isApproved: true,
                      },
                    },
                  });
                }}
              >
                Approve
              </Button>
            </Text>
            <Text>
              <Button
                disabled={
                  loadingUWQuoteApproval ||
                  loadingFireQuoteVar ||
                  !underWriterComment
                    ? true
                    : false
                }
                size={'small'}
                className={'w-full h-10'}
                flat
                onClick={(_) => {
                  doUWQuoteApproval({
                    variables: {
                      input: {
                        quoteNumber: fireQuote?.quoteNumber,
                        updatedUWQuote: {
                          clauses: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.clauses
                              ?.defaultClauses
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.clauses
                                  ?.defaultClauses
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses?.filter(
                                (udc) => udc,
                              ),
                          },
                          warranties: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.warranties
                              ?.defaultWarranties
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.warranties
                                  ?.defaultWarranties
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties?.filter(
                                (udw) => udw,
                              ),
                          },
                          exclusions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.exclusions
                              ?.defaultExclusions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.exclusions
                                  ?.defaultExclusions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions?.filter(
                                (ude) => ude,
                              ),
                          },
                          conditions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.conditions
                              ?.defaultConditions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.conditions
                                  ?.defaultConditions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions?.filter(
                                (udc) => udc,
                              ),
                          },
                        },
                        underwriterComment: underWriterComment,
                        // underwriterComment:
                        //   fireQuote?.tabDetails?.additionalTabDetails
                        //     ?.underwriterComment,
                        isApproved: false,
                      },
                    },
                  });
                }}
              >
                Reject
              </Button>
            </Text>
          </>
        ) : (
          <Text className={'flex space-x-4 items-center justify-end'}>
            <Text>
              <Button
                disabled={
                  loadingUWQuoteApproval ||
                  loadingFireQuoteVar ||
                  !underWriterComment
                    ? true
                    : false
                }
                size={'small'}
                className={'mt-2 w-44 max-h-10'}
                flat={false}
                onClick={(_) => {
                  doUWQuoteApproval({
                    variables: {
                      input: {
                        quoteNumber: fireQuote?.quoteNumber,
                        updatedUWQuote: {
                          clauses: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.clauses
                              ?.defaultClauses
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.clauses
                                  ?.defaultClauses
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses?.filter(
                                (udc) => udc,
                              ),
                          },
                          warranties: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.warranties
                              ?.defaultWarranties
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.warranties
                                  ?.defaultWarranties
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties?.filter(
                                (udw) => udw,
                              ),
                          },
                          exclusions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.exclusions
                              ?.defaultExclusions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.exclusions
                                  ?.defaultExclusions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions?.filter(
                                (ude) => ude,
                              ),
                          },
                          conditions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.conditions
                              ?.defaultConditions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.conditions
                                  ?.defaultConditions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions?.filter(
                                (udc) => udc,
                              ),
                          },
                        },
                        underwriterComment: underWriterComment,
                        // underwriterComment:
                        //   fireQuote?.tabDetails?.additionalTabDetails
                        //     ?.underwriterComment,
                        isApproved: true,
                      },
                    },
                  });
                }}
              >
                Approve
              </Button>
            </Text>
            <Text>
              <Button
                disabled={
                  loadingUWQuoteApproval ||
                  loadingFireQuoteVar ||
                  !underWriterComment
                    ? true
                    : false
                }
                size={'small'}
                className={'mt-2 w-44 max-h-10'}
                flat
                onClick={(_) => {
                  doUWQuoteApproval({
                    variables: {
                      input: {
                        quoteNumber: fireQuote?.quoteNumber,
                        updatedUWQuote: {
                          clauses: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.clauses
                              ?.defaultClauses
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.clauses
                                  ?.defaultClauses
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses?.filter(
                                (udc) => udc,
                              ),
                          },
                          warranties: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.warranties
                              ?.defaultWarranties
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.warranties
                                  ?.defaultWarranties
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties?.filter(
                                (udw) => udw,
                              ),
                          },
                          exclusions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.exclusions
                              ?.defaultExclusions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.exclusions
                                  ?.defaultExclusions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions?.filter(
                                (ude) => ude,
                              ),
                          },
                          conditions: {
                            default: fireQuote?.tabDetails
                              ?.additionalTabDetails?.conditions
                              ?.defaultConditions
                              ? fireQuote?.tabDetails
                                  ?.additionalTabDetails?.conditions
                                  ?.defaultConditions
                              : [],
                            userDefined:
                              fireQuote?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions?.filter(
                                (udc) => udc,
                              ),
                          },
                        },
                        underwriterComment: underWriterComment,
                        // underwriterComment:
                        //   fireQuote?.tabDetails?.additionalTabDetails
                        //     ?.underwriterComment,
                        isApproved: false,
                      },
                    },
                  });
                }}
              >
                Reject
              </Button>
            </Text>
          </Text>
        ))}
      {['quote saved', 'underwriter approved']?.includes(
        fireQuote?.status?.toString()?.toLowerCase(),
      ) &&
        role?.toString()?.toLowerCase() !== 'underwriter' &&
        (screenType?.toString()?.toLowerCase() === 'mobile' ? (
          // <TransactionComponent>
            <Text>
              <Button
                disabled={
                  loadingUWQuoteApproval || loadingFireQuoteVar
                }
                size={'small'}
                className={'w-full h-10'}
                flat={false}
                onClick={async (_) => {
                  try {
                    const getFireQuoteVar = fetchQuery({
                      query: GET_FIRE_POLICY_VAR_DETAILS,
                    });
                    const { data: fireQuoteVarData } =
                      await getFireQuoteVar;
                    const fireQuote = fireQuoteVarData?.fireQuote;
                    updateBuyFirePolicyVar({
                      quoteData: fireQuote,
                      quoteNumber: fireQuote?.quoteNumber,
                      // coverData: {
                      //   addOnCovers:
                      //     workmenCompensationQuote?.addOnCovers,
                      //   rawRiskData: updatedRawRiskData,
                      // },
                      proposerDetailsMeta:
                        fireQuote?.tabDetails?.customerTabDetails
                          ?.customerDetails?.customerMeta,
                      proposerDetails:
                        fireQuote?.tabDetails?.customerTabDetails
                          ?.customerDetails?.customer,
                      customerFetchRequiredOnLoad:
                        fireQuote?.tabDetails?.customerTabDetails
                          ?.customerDetails?.customerDetails?.customer
                          ?.id !== ''
                          ? true
                          : false,
                      intermediary: {
                        code: fireQuote?.intermediaryDetails?.code ||
                          fireQuoteVarData?.selectedIntermediary
                            ?.intermediaryCode ,
                        intermediaryName:
                          fireQuoteVarData?.selectedIntermediary
                            ?.intermediaryName,
                        branchOfficeCode: fireQuote?.intermediaryDetails?.location ||
                          fireQuoteVarData?.selectedIntermediary
                            .branchOfficeCode 
                          ,
                        branchOfficeName:
                          fireQuoteVarData?.selectedIntermediary
                            ?.branchOfficeName,
                        fieldUserCode:
                          fireQuoteVarData?.selectedIntermediary
                            ?.fieldUserCode,
                        fieldUserName:
                          fireQuoteVarData?.selectedIntermediary
                            ?.fieldUserName,
                      },
                      premiumData: {
                        discount: [],
                        loading: [],
                        netPremium:
                          fireQuote?.finalisedPremium
                            ?.locationNetPremium,
                        stampDuty:
                          fireQuote?.finalisedPremium?.stampDuty,
                        gst: fireQuote?.finalisedPremium?.locationGST,
                        totalPremium:
                          fireQuote?.finalisedPremium
                            ?.locationTotalPremium,
                      },
                    });
                    history.push(
                      `/quote/Fire/buy/${lobCode}/${productName}/${productCode}`,
                    );
                  } catch (error) {
                    setAlerts([
                      ...alerts,
                      {
                        header: `Intermediary details fetch failed`,
                        id: Date.now(),
                        content: (
                          <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                            <span>
                              {getGraphQLErrorMessage(error)}
                            </span>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                  }
                }}
                iconPost={<FontAwesomeIcon icon={faChevronRight} />}
              >
                Proceed To Buy
              </Button>
            </Text>
         // </TransactionComponent>
        ) : (
          // <TransactionComponent>
            <Text
              className={'flex space-x-4 items-center justify-end'}
            >
              <Text>
                <Button
                  disabled={
                    loadingUWQuoteApproval || loadingFireQuoteVar
                  }
                  size={'small'}
                  className={'mt-2 w-52 max-h-10'}
                  flat={false}
                  onClick={async (_) => {
                    try {
                      const getFireQuoteVar = fetchQuery({
                        query: GET_FIRE_POLICY_VAR_DETAILS,
                      });
                      const { data: fireQuoteVarData } =
                        await getFireQuoteVar;
                      const fireQuote = fireQuoteVarData?.fireQuote;
                      updateBuyFirePolicyVar({
                        quoteData: fireQuote,
                        quoteNumber: fireQuote?.quoteNumber,
                        // coverData: {
                        //   addOnCovers:
                        //     workmenCompensationQuote?.addOnCovers,
                        //   rawRiskData: updatedRawRiskData,
                        // },
                        proposerDetailsMeta:
                          fireQuote?.tabDetails?.customerTabDetails
                            ?.customerDetails?.customerMeta,
                        proposerDetails:
                          fireQuote?.tabDetails?.customerTabDetails
                            ?.customerDetails?.customer,
                        customerFetchRequiredOnLoad:
                          fireQuote?.tabDetails?.customerTabDetails
                            ?.customerDetails?.customer?.id !== ''
                            ? true
                            : false,
                        intermediary: {
                          code:fireQuote?.intermediaryDetails?.code ||
                            fireQuoteVarData?.selectedIntermediary
                              ?.intermediaryCode ,
                          intermediaryName:
                            fireQuoteVarData?.selectedIntermediary
                              ?.intermediaryName,
                          branchOfficeCode:
                          fireQuote?.intermediaryDetails?.location ||
                            fireQuoteVarData?.selectedIntermediary
                              .branchOfficeCode 
                            ,
                          branchOfficeName:
                            fireQuoteVarData?.selectedIntermediary
                              ?.branchOfficeName,
                          fieldUserCode:
                            fireQuoteVarData?.selectedIntermediary
                              ?.fieldUserCode,
                          fieldUserName:
                            fireQuoteVarData?.selectedIntermediary
                              ?.fieldUserName,
                        },
                        premiumData: {
                          discount: [],
                          loading: [],
                          netPremium:
                            fireQuote?.finalisedPremium
                              ?.locationNetPremium,
                          stampDuty:
                            fireQuote?.finalisedPremium?.stampDuty,
                          gst: fireQuote?.finalisedPremium
                            ?.locationGST,
                          totalPremium:
                            fireQuote?.finalisedPremium
                              ?.locationTotalPremium,
                        },
                      });
                    history.push(
                        `/quote/Fire/buy/${lobCode}/${productName}/${productCode}`,
                      );
                    } catch (error) {
                      setAlerts([
                        ...alerts,
                        {
                          header: `Intermediary details fetch failed`,
                          id: Date.now(),
                          content: (
                            <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                              <span>
                                {getGraphQLErrorMessage(error)}
                              </span>
                            </div>
                          ),
                          type: 'error',
                          timeout: null,
                          disableClose: false,
                        },
                      ]);
                    }
                  }}
                  iconPost={<FontAwesomeIcon icon={faChevronRight} />}
                >
                  Proceed To Buy
                </Button>
              </Text>
            </Text>
          //</TransactionComponent>
        ))}
      <NotificationList
        {...{
          items: alerts,
          resetAlerts: (idx) => {
            const alertToBeRemovedPos = alerts.findIndex(
              (a) => a.id === idx,
            );
            setAlerts([
              ...alerts.slice(0, alertToBeRemovedPos),
              ...alerts.slice(alertToBeRemovedPos + 1, alerts.length),
            ]);
          },
        }}
      />
    </div>
  );
}
